export default class NavigationFixed {
  static init () {
    const navigation = document.getElementById('navigation')
    const contentContainer = document.getElementById('content-container')

    if (navigation) {
      contentContainer.style.marginTop = '0'

      window.addEventListener('scroll', () => {
        const { classList } = navigation

        if (window.scrollY <= 40) {
          contentContainer.style.marginTop = '0'
          classList.remove('navigation-not-top', 'navigation-fixed')
          return
        }
        else {
          contentContainer.style.marginTop = '103px'
          classList.add('navigation-fixed')
          
          if (window.scrollY > 80) {
            classList.add('navigation-move-top')
          }
          else {
            classList.remove('navigation-move-top')
          }
        }
      })
    }
  }
}
